import { AnimatedContentLoader, Tab, Tabs } from '@components'
import { DocumentAttachmentPreview } from '@containers/DocumentAttachmentPreview'
import { DocumentBankDetails } from '@containers/DocumentBankDetails'
import { useBusinessContext } from '@context'
import { fetchDocument, IImportData } from '@query'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query'
interface Props {
  documentId?: number
  importData?: IImportData
  attachmentIds: number[]
}

export const DocumentFormExtraDetailView: React.FC<Props> = ({
  documentId,
  importData,
  attachmentIds
}) => {
  const { slug } = useBusinessContext()
  const { t } = useTranslation()

  const { data, isLoading } = useQuery({
    queryKey: [slug, 'documents', documentId],
    queryFn: () => fetchDocument({ slug, documentId }),
    enabled: !!documentId && !importData,
    staleTime: 1000 * 60 * 5,
    refetchOnMount: false
  })

  const importSource = importData ?? data?.import_data

  return (
    <AnimatedContentLoader isLoading={isLoading}>
      <Tabs queryKey="extra" wrapperStyles={{ height: '100%' }} hideTabsWhenSingle>
        <Tab key="attachments" name={t('document.formExtra.tabAttachments')}>
          <DocumentAttachmentPreview attachmentIds={attachmentIds} />
        </Tab>

        {importSource && (
          <Tab key="import-data" name={t('document.importSource.tabName')}>
            <DocumentBankDetails import_data={importSource} />
          </Tab>
        )}
      </Tabs>
    </AnimatedContentLoader>
  )
}
